import { BackgroundColor } from '@ampcore/ampcom-contracts'

export const advisorQuestionBackgroundColors = [
  BackgroundColor.STONE,
  BackgroundColor.MINT_TINT,
  BackgroundColor.LIME_TINT,
  BackgroundColor.PURPLE_TINT,
  BackgroundColor.BERRY_TINT,
  BackgroundColor.ORANGE_TINT,
  BackgroundColor.WHITE
] as const

/**
 * @deprecated These colors are deprecated and should not be used in new implementations.
 * They will be removed in a future release.
 */
export const deprecatedAdvisorQuestionColors = [
  'Purple',
  'Mint',
  'Lime'
] as const

export type DeprecatedAdvisorQuestionColor =
  (typeof deprecatedAdvisorQuestionColors)[number]

export type AdvisorQuestionBackgroundColor =
  | (typeof advisorQuestionBackgroundColors)[number]
  | DeprecatedAdvisorQuestionColor
